import firebase from "firebase";
import "firebase/auth";
import "firebase/firestore";

import firebaseConfigDefault from "./firebase-config-default";
import firebaseConfigStaging from "./firebase-config-staging";

// console.log('location.host', location.host);
// Initialize Firebase
if (location.host.indexOf('yokohama-city-youchien-dev') != -1) {
    // yokohama-city-youchien-dev
    // console.log('yokohama-city-youchien-dev');
    firebase.initializeApp(firebaseConfigDefault);
} else if (location.host.indexOf('yokohama-city-youchien-staging') != -1) {
    // yokohama-city-youchien-staging
    // console.log('yokohama-city-youchien-staging');
    firebase.initializeApp(firebaseConfigStaging);
} else {
    // localhost:8080
    // console.log('yokohama-city-youchien-staging');
    firebase.initializeApp(firebaseConfigStaging);    
}

// //接続先指定 デバッグ用
// const functions = firebase.functions();
// functions.useFunctionsEmulator('http://localhost:5001');

export default firebase;
